import { Environment } from './environment.type';

const url = window.location.href;
const matches = url.match(/^http(s?)?\:\/\/([^\/?#]+)/);

export const environment: Environment = {
  production: false,
  baseUrl: matches[0],
  sessionSoftTimeout: 10 * 60, // seconds
  sessionHardTimeout: 60 * 60, // seconds

  sentry: {
    dsn: 'https://d3de4e3e97010ed97501f14a37973f6a@sentry.c0d1um.io/240',
    environment: 'uat',
  },

  enableFlexibleShiftAdjustRoster: true,
  enableUserManagementCurrentTemplateForPMPA: false,
  enableImportPage: true,
  enableAnnouncement: true,
  enableSurveyQuestionImport: true,
  enableSamlLogin: true,
};
